module.exports = __webpack_public_path__ + "img/amount-icon.31306b1e.svg";